import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-sanificazioni',
  imports: [CommonModule],
  templateUrl: './sanificazioni.html',
  styleUrls: ['./sanificazioni.scss'],
})
export class SanificazioniComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Sanificazione ambienti a Pescara | SAMI Pulizie',
      description:
        'Sanificazione professionale e certificata per uffici, aziende, condomini, palestre e abitazioni private a Pescara. Interventi rapidi e documentati.',
      keywords:
        'sanificazione Pescara, sanificazione professionale, disinfezione ambienti, igienizzazione uffici, sanificazione palestre, SAMI Pulizie',
      canonicalUrl: '/sanificazioni',

      ogTitle: 'Sanificazione ambienti a Pescara | SAMI Pulizie',
      ogDescription:
        'Interventi certificati con prodotti professionali per eliminare virus, batteri e agenti contaminanti.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Sanificazione ambienti a Pescara | SAMI Pulizie',
      twitterDescription:
        'Sanificazione professionale e certificata per uffici, aziende, condomini, palestre e abitazioni private.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Sanificazione ambienti',
        description:
          'Servizio professionale di sanificazione per ambienti privati e aziendali. Interventi certificati.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: {
          '@type': 'AdministrativeArea',
          name: 'Pescara',
        },
        url: 'https://samipulizie.it/sanificazioni',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
